<div class="h-14 min-w-full px-2 py-4">
    <div>
        <div class="sm:block flex justify-between">
         <div class="w-full flex justify-between">
            <nav class="flex space-x-4" aria-label="Tabs">
              <!-- Current: "bg-indigo-100 text-indigo-700", Default: "text-gray-500 hover:text-gray-700" -->
               <a (click)="selectTab('EMPLOYEE')" 
                  class="text-gray-500 hover:text-gray-700 px-3 py-2 space-x-1 font-medium primary-font rounded-md flex justify-center items-center text-base cursor-pointer"
                  [ngClass]="{'bg-indigo-100 text-indigo-700' : currentTab === 'EMPLOYEE'}"
                  > 
                  <mat-icon
                  class="m-0 mr-1 icon-size-5 text-gray-500 dark:text-gray-400"
                  [ngClass]="{'text-indigo-700 dark:text-indigo-700' : currentTab === 'EMPLOYEE'}"
                  [svgIcon]="'heroicons_outline:user'">
                  </mat-icon> <span>{{'text.users' | translate}}</span>
               </a>
        
               <a (click)="selectTab('JOBS')" 
                  class="text-gray-500 hover:text-gray-700 px-3 py-2 space-x-1 font-medium primary-font rounded-md flex justify-center items-center text-base cursor-pointer"
                  [ngClass]="{'bg-indigo-100 text-indigo-700' : currentTab === 'JOBS'}"
                  > 
                  <mat-icon
                  class="m-0 mr-1 icon-size-5 text-gray-500 dark:text-gray-400"
                  [ngClass]="{'text-indigo-700 dark:text-indigo-700' : currentTab === 'JOBS'}"
                  [svgIcon]="'heroicons_outline:briefcase'">
                  </mat-icon> <span>{{'text.jobs' | translate}}</span>
               </a>
  
               <a (click)="selectTab('ROUTES')" 
                  class="text-gray-500 hover:text-gray-700 px-3 py-2 space-x-1 font-medium primary-font rounded-md flex justify-center items-center text-base cursor-pointer"
                  [ngClass]="{'bg-indigo-100 text-indigo-700' : currentTab === 'ROUTES'}"
                  > 
                  <mat-icon
                  class="m-0 mr-1 icon-size-5 text-gray-500 dark:text-gray-400"
                  [ngClass]="{'text-indigo-700 dark:text-indigo-700' : currentTab === 'ROUTES'}"
                  [svgIcon]="'heroicons_outline:map'">
                  </mat-icon> <span>{{'text.routes' | translate}}</span>
               </a>
               <a (click)="selectTab('ASSETS')" 
                  class="text-gray-500 hover:text-gray-700 px-3 py-2 space-x-1 font-medium primary-font rounded-md flex justify-center items-center text-base cursor-pointer"
                  [ngClass]="{'bg-indigo-100 text-indigo-700' : currentTab === 'ASSETS'}"
                  > 
                  <mat-icon
                  class="m-0 mr-1 icon-size-5 text-gray-500 dark:text-gray-400"
                  [ngClass]="{'text-indigo-700 dark:text-indigo-700' : currentTab === 'ASSETS'}"
                  [svgIcon]="'heroicons_outline:cube'">
                  </mat-icon> <span>{{'text.assets' | translate}}</span>
               </a>
               <a (click)="selectTab('PROPERTY')" 
                  class="text-gray-500 hover:text-gray-700 px-3 py-2 space-x-1 font-medium primary-font rounded-md flex justify-center items-center text-base cursor-pointer"
                  [ngClass]="{'bg-indigo-100 text-indigo-700' : currentTab === 'PROPERTY'}"
                  >
                  <mat-icon
                  class="m-0 mr-1 icon-size-5 text-gray-500 dark:text-gray-400"
                  [ngClass]="{'text-indigo-700 dark:text-indigo-700' : currentTab === 'PROPERTY'}"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z" />
                  </svg>
                  </mat-icon> <span>{{'text.properties' | translate}}</span>
               </a>
               <a (click)="selectTab('CUSTOMER')" 
                  class="text-gray-500 px-3 py-2 space-x-1 font-medium primary-font rounded-md flex justify-center items-center text-base cursor-pointer" 
                  [ngClass]="{'bg-indigo-100 text-indigo-700' : currentTab === 'CUSTOMER'}"
                 > 
                  <mat-icon
                  class="m-0 mr-1 icon-size-5 text-gray-500 dark:text-gray-400"
                  [ngClass]="{'text-indigo-700 dark:text-indigo-700' : currentTab === 'CUSTOMER'}"
                  [svgIcon]="'heroicons_outline:user-group'">
                  </mat-icon> <span>{{'customers.text' | translate}}</span>
               </a>
               <a (click)="selectTab('ORGANIZATION')" class="text-gray-500 hover:text-gray-700 px-3 py-2 space-x-1 font-medium primary-font rounded-md flex justify-center items-center text-base cursor-pointer" [ngClass]="{'bg-indigo-100 text-indigo-700' : currentTab === 'ORGANIZATION'}"> 
                  <mat-icon
                  class="m-0 mr-1 icon-size-5 text-gray-500 dark:text-gray-400"
                  [ngClass]="{'text-indigo-700 dark:text-indigo-700' : currentTab === 'ORGANIZATION'}"
                  [svgIcon]="'heroicons_outline:office-building'">
                  </mat-icon> <span>{{'text.organizations' | translate}}</span>
               </a>
        
            </nav>
            <div class="mr-2 flex space-x-2">
               <a 
                  *ngIf="settings['overlay_territories']"
                  (click)="openLegend()"
                  mat-stroked-button 
                  class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
               >
                  <span class="primary-font text-base leading-loose">{{'dispatchBoard.icons.tooltip.legend' | translate}}</span>
               </a>
               <a 
                  (click)="openSettings()"
                  mat-stroked-button 
                  class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
               >
                  <span class="primary-font text-base leading-loose">
                     <i class="ti ti-settings text-xl mr-1 relative top-0.5 text-gray-600"></i>
                     {{'text.settings' | translate}}
                  </span>
               </a>
            </div>
         </div>
        </div>
      </div>
</div>

